export default __webpack_public_path__ + "static/media/mobile-4.f8814c0a.png";